import { injectEntity } from '../../../../../../../common/store/base/injectEntity';
import { injectEntityList } from '../../../../../../../common/store/base/injectEntityList';
import { IUnitCardModel } from '../../../../projectRole/entity/interface/IUnitCardModel';
import { IContentExportUI, IUnitWithCheckbox } from './IContentExportUI';

export class ContentExportUI implements IContentExportUI {
  public units = injectEntityList<IUnitCardModel>([]);
  public filteredUnits = injectEntityList<IUnitCardModel>([]);

  public isLoading = injectEntity<boolean>(false);
  public isSelectedAll = injectEntity<boolean>(false);
  public unitsForExporting = injectEntityList<IUnitWithCheckbox>([]);
  public isExporting = injectEntity<boolean>(false);
  public exportProgress = injectEntity<{ current: number; total: number }>({
    current: 0,
    total: 0,
  });
  public isPasswordDialogOpen = injectEntity<boolean>(false);
  public exportPassword = injectEntity<string>('');
  public validationErrors = injectEntityList<string>([]);
  public searchQuery = injectEntity<string>('');
  public isPasswordVisible = injectEntity<boolean>(false);
}
